import axios from 'axios';

// Set the base URL to point to the events API endpoint


const BASE_URL = `${process.env.REACT_APP_API_URL}/api/events`;


// Function to get all events
export const fetchEvents = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/all`); // Adjusted endpoint for fetching all events
    return response.data;
  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};

// Function to create an event (using FormData for file upload support)
export const createEvent = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL}/create`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Needed for file uploads
      },
    });
    
    // Handle successful response
    console.log('Event created successfully:', response.data);
    return response.data;
  } catch (error) {
    // Enhanced error logging
    console.error('Error creating event:', error.response ? error.response.data : error.message);
    
    if (error.response) {
      console.error('Error details:', {
        status: error.response.status,
        data: error.response.data,
      });
    }

    throw error; // Rethrow error for further handling if needed
  }
};


// Function to update an event
export const updateEvent = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL}/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Needed for file uploads
      },
    });
    console.log('Response from update:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating event:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Function to delete an event
export const deleteEvent = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/${id}`); // Correct endpoint
    return response.data;
  } catch (error) {
    console.error('Error deleting event:', error.response ? error.response.data : error.message);
    throw error;
  }
};


// Function to fetch a single event by ID
export const getEventById = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/get/${id}`); // Fetch by ID
    return response.data;
  } catch (error) {
    console.error('Error fetching event by ID:', error);
    throw error;
  }

};


